
/*
    Default Section Divs
    - height: default is h-[85vh], can be overridden using Tailwind classes
*/
export function SectionDiv({ children, className, height }: { children: React.ReactNode; className?: string; height?: string; }) {
    return (
        <div className={`shadow-md px-4 py-2 mx-auto w-full overflow-hidden bg-white dark:bg-stone-900 ${height ? height : "h-[85vh]"} ${className}`}>
            {children}
        </div>
    )
}